import React, { useEffect, useRef, useState } from "react";
import { FaArrowDownWideShort } from "react-icons/fa6";
import { sortProps } from "../../views/home/home";
import "./sortSerch.css";

interface props {
	setSort: (e: sortProps) => void;
}

interface divProps {
	height: number;
	width: number;
	x: number;
	y: number;
}

const SortBy = ({ setSort }: props) => {
	const [value, setValue] = useState("Pozostało");
	const [isFocus, setIsFocus] = useState(false);
	const [positionImage, setPositionImage] = useState<divProps>({ height: 0, width: 0, x: 0, y: 0 });
	const ref = useRef<HTMLDivElement | null>(null);

	useEffect(() => {}, []);
	const handlerSort = () => {
		if (isFocus) {
			setIsFocus(false);
		} else {
			setIsFocus(true);
		}
		return null;
	};
	const handlerValue = (a: string) => {
		setValue(a);
		setIsFocus(false);
		setSort(a);
	};

	return (
		<>
			<div ref={ref} className="sortSerch">
				<p className="textSortowanie" style={{ left: positionImage.x + 15, top: positionImage.y - positionImage.height }}>
					Sortowanie{" "}
				</p>
				<div onClick={handlerSort}>
					<div className={!isFocus ? "sortContainer" : "sortContainer2"}>
						{!isFocus && <p>{value}</p>}
						{!isFocus && <FaArrowDownWideShort className="iconSort" color={isFocus ? "blue" : "black"} />}
						{isFocus && (
							<div className="sortItems">
								<p className={value === "Pozostało" ? "selected" : ""} onClick={() => handlerValue("Pozostało")}>
									Pozostało
								</p>
								<p className={value === "A-Z" ? "selectedStyle" : ""} onClick={() => handlerValue("A-Z")}>
									A-Z
								</p>
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default SortBy;
